module.exports = __webpack_public_path__ + "img/rf4.de3c1b53.png";